import { Space } from 'antd';
import React from 'react';
import { Wrapper, Heading, Extra } from './styled';

function PageHeader({ title, extra = [], back = null }: any) {

  return (
    <Wrapper>
      <Space>
        {back}
        <Heading>{title}</Heading>
      </Space>
      <Extra>
        <Space>{extra}</Space>
      </Extra>
    </Wrapper>
  )
}

export default PageHeader;